exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-aggregate[data-v-5bbc3b24]{background:#fafafa;line-height:26px;border-radius:10px}", ""]);

// exports
